import "../css/global.scss";

import select2 from "select2/dist/js/select2.full";

select2($);

import { initChoices } from "./utils/initChoices";
import { select2ify } from "./utils/select2ify";
import "./utils/doublesubmit";

// Menüs aufklapbar machen

$(".navigation-box .box-head").on("click", function () {
	$(".box-content, .box-end", $(this).parent()).toggle("fast");
	return false;
});

select2ify($(".select2"));
initChoices();

$(".datepicker").datepicker({
	startView: "months",
	language: "de",
	autoclose: true,
	forceParse: false,
	format: "dd.mm.yyyy",
});

// Größe der Textareas deren Inhalt anpassen
$("textarea").elastic();
